import { keyBy, uniqBy } from 'lodash-es';

export function mergeUniqLists<T>({
  current = [],
  incoming = [],
  uniq,
}: {
  current: T[] | undefined;
  incoming: T[] | undefined;
  uniq(node: T): string;
}) {
  const incomingByKey = keyBy(incoming, uniq);

  return uniqBy([...current.map(value => incomingByKey[uniq(value)] || value), ...incoming], uniq);
}
